<template>
  <el-container>
    <el-main>
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
      </el-form>
      <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addBlogCa" class="but-cls">
        添加博客分类
      </el-button>
      <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteBlogCategoryMore" class="but-cls">删除博客分类
      </el-button>
      <el-table
          :data="OpenclassData"
          border
          @selection-change="handleSelectionChange"
          highlight-current-row
          style="width: 100%">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            type="index"
            label="序号"
            width="50"
            fixed="left"
        >
        </el-table-column>
        <el-table-column
            prop="categoryName"
            label="分类名称"
        >
       </el-table-column>
       <el-table-column
            prop="categoryNameEn"
            label="分类英文名称"
        >
       </el-table-column>
      <el-table-column
            prop="createTime"
            label="创建时间"
        >
       </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="200"
        >
          <template slot-scope="scope">
            <el-button @click="upCategory(scope.$index, scope.row)" type="text" size="small">上移</el-button>
            <el-button @click="downCategory(scope.$index, scope.row)" type="text" size="small">下移</el-button>
            <el-button type="text" size="small" @click="updateBlogcategory(scope.row)">修改</el-button>
            <el-button @click="deleteBlogCategory(scope.$index, scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 10px; float: right; margin-right: 10px">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import {dateFormat, monthFormat} from '@/api/utils.js';

  const formData = {};
  export default {
    data() {
      return {
        formData: JSON.parse(JSON.stringify(formData)),
        OpenclassData: [],
        href: '',
        searchData: {
          size: 10,
          page: 1,
          orgCode: 'blcuonline'
        },
        categoryData: [],
        commoditys: [],
        ccId2Data: [],
        organizationData: [],
        showEdit: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        multipleSelection: [],
        courseOptions: [],
        
      };
    },
    methods: {
      upCategory(index, row) {
        let params = row;
        https.fetchPost('/webBlogCategory/updateUpSort', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.search();
          } else {
            this.$message({
              message: '操作失败:' + msg,
              type: 'info'
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      downCategory(index, row) {
        let params = row;
        https.fetchPost('/webBlogCategory/updateDownSort', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.search();
          } else {
            this.$message({
              message: '操作失败:' + msg,
              type: 'info'
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      handleEdit(index, row) {
        this.showEdit[row.commodityId] = true;
        this.search();
      },
      addBlogCa() {
        this.$router.push({
          name: 'addblogcategory',
          params: {'title': '添加博客分类内容！'}
        });
      },
      dateFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return dateFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = [];
        for (let index in val) {
          this.multipleSelection[index] = val[index].categoryId;
        }
      },
      updateBlogcategory(row) {
        console.log("row:",row);
        this.$router.push({
          name: 'addblogcategory',
          params: row
        });
      },
       deleteBlogCategoryMore() {
        let length = this.multipleSelection.length;
        this.$confirm('此操作将删除' + length + '条博客分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let multipleSelection = this.multipleSelection;
          let params = {'categoryIdList': multipleSelection};
          https.fetchPost('/webBlogCategory/deleteCategory', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteBlogCategory(index, row) {
        this.$confirm('此操作将删除该博客分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {'categoryIdList': []};
          params.categoryIdList.push(row.categoryId);
          https.fetchPost('/webBlogCategory/deleteCategory', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      monthFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return monthFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      search(val) {
        let params = this.searchData;
        https.fetchPost('/webBlogCategory/list', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.OpenclassData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
            }
        );
      },
      // loadOrganization() {
      //   let params = {};
      //   https.fetchGet('/managerOrganization/getOrganizationList', params, 'from').then((data) => {
      //     let code = data.data.code;
      //     if (code == 200) {
      //       let d = data.data.data;
      //       if(data.data.data) {
      //         this.organizationData = data.data.data;
      //       }
      //     } else {
      //       this.$message({
      //         type: 'info',
      //         message: '加载失败' + msg
      //       });
      //     }

      //   }).catch(err => {
      //         this.$message.error('网络错误');
      //       }
      //   );
      // },
    },
    created: function() {
      this.searchData.orgCode = this.$store.state.orgCode;
      // this.loadOrganization();
      this.search();
    }
  };
</script>

<style scoped>
  .but-cls {
    margin-bottom: 10px;
  }
  
  .line {
    text-align: center;
  }
  
  .edit-cell {
    width: 60%;
  }
  
  .cls-col {
    margin-right: 20px;
  }
  
  .target {
    margin-left: 10px;
    color: #409EFF;
  }
</style>
